import React from 'react'
import { Row, Col } from '@iqueue/ui-kit'
import './authStyle.css'
import { t } from '../../hooks/useTranslate'

export default function NoPermissions() {
  return <div className="no-permissions">
    <Row>
      <Col size={ 12 }>
        <h2>{ t('noPermissions.title') }</h2>
        <p>{ t('noPermissions.message') }</p>
        <p>{ t('noPermissions.suggestion') }</p>
      </Col>
    </Row>
  </div>
}

